const getTemplatePrintCss = printType => {
  if (printType === 'A5') {
    return `<style>
    body {
      width: 100%;
      height: 100%;
      margin: 0;
      padding: 0;
      background-color: #FAFAFA;
      font: 25pt "Arial";
    }
    * {
      box-sizing: border-box;
      -moz-box-sizing: border-box;
    }

    .page {
      width: 100%;
      min-height: 100%;
      border-radius: 5px;
      background: white;

      box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    }
    .page-without-break {
      width: 100%;
      min-height: 100%;
      margin: auto auto;
      border-radius: 5px;
      background: white;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    }
    .noDisplay{
      display: none;
    }
    .subPage {
      float: left;
      margin: 0;
      padding-top: 5px;
      width: 210mm;
      height: 148.5mm;
      border: 1px solid black;
      position: relative;
    }
    // .transition1{
    //   transform: translate(0px,0px)
    // }
    // .transition2{
    //   transform: translate(0px,0px)
    // }

    .header-area {
      width: 100%;
      position:absolute;
      top:9%;
      color: black;
      font-size: 27pt;
      font-style: arial;
      font-weight: bold;
      text-align: center;
    }

    .header-text {
      color: red;
      font-size: 24pt;
      font-style: arial;
      padding-bottom: 100px;
      border:1px solid black;
      font-weight: bold;
      width: 100%;
      text-align: center;
    }

    .center-area {
      width: 100%;
      position:absolute;
      top:25%;
      display: flex;
      flex-direction: column;
    }
    .offer-text {
      justify-content: center;
       margin: 0;
       width: 100%;
       display:flex;
     }

    .price-container {
      position:absolute;
      top:64%;
      width:90%;
      left: 50%;
      transform: translateY(-50%) translateX(-50%);
      display: flex;
      justify-content: space-between;
    }
    .price-label {
      font-style: arial;
      font-size: 16pt;
      font-weight: bold;
    }
    .rupeeSymbol{
      font-weight: bold;
      font-size: 36pt;
      font-family: Arial;
      padding-top: 8px;
    }
    .percentageSymbol{
      font-weight: bold;
      font-size: 36pt;
      font-family: Arial;
      padding-top: 20px;
    }

    .buyClass{
      width: 40%;
      text-align: center;
      font-weight: bold;
      font-size: 35pt;
      font-family: Arial;
      position : absolute;
      top:35%;
      left:40%;
      border: 1px solid black;
      transform: translateY(-50%) translateX(-50%);
    }
    // .ClassSave3{
    //   width: 75%;
    //   text-align: center;
    //   font-weight: bold;
    //   font-size: 20pt;
    //   font-family: Arial;
    //   position : absolute;
    //   color: blue;
    //   top:35%;
    //   left:40%;
    //   transform: translateY(-50%) translateX(-50%);
    // }

    .savefooter{

    position:fixed;
    left:0;
    bottom:0;
    width:100%;
    color:red;
    text-align:right;
    left-margin: 1px;
    padding: 10px;

  }

    .offer-text-rupee {
      font-weight: bold;
      font-size: 54pt;
      font-family: Arial;
      vertical-align: super;
      position: relative;
    }
    .mrp-container {
      position: absolute;
      right:4%;
      top:59%;
       border: 1px solid black;
    }
    .save-container {
      position: absolute;
      left:4%;
      top:59%
    }
   .description {
      position: absolute;
      padding:0;
      left: 50%;
      transform: translateY(-50%) translateX(-50%);
      top:81%;
      width: 65%;
      text-align: center;
       padding:0;
       color: #000000;
       font-weight: bold;
       font-size: 13pt;
       font-family: Arial;
    }
    .familyDescription{
      position: absolute;
      padding:0;
      left: 50%;
      transform: translateY(-50%) translateX(-50%);
      top:75%;
      width: 65%;
      text-align: center;
       padding:0;
       color: #000000;
       font-weight: bold;
       font-size: 11pt;
       font-family: Arial;
    }

    .description-text {
       text-align: center;
       padding:0;
       color: #000000;
       font-weight: bold;
       font-size: 11pt;
       font-family: Arial;
       width: 100%;
     }

    .footer-date {
      position: absolute;
      bottom: 1%;
      font-weight: bold;
      font-size: 5pt;
      font-family: Arial;
      right: 2%
    }
    .validTo {
      position: absolute;
      bottom: 1%;
      font-weight: bold;
      font-size: 5pt;
      font-family: Arial;
      left:2%;
    }
    @page {
      size: A4;
      margin-top: 2mm;
    }
    @media print {
        html, body {
          width: 210mm;
          height: 297mm;
        }
        div {
          break-inside: avoid;
        }
      .page {
        border: initial;
        border-radius: initial;
        width: initial;
        margin: 5mm auto;
        min-height: initial;
        box-shadow: initial;
        background: initial;
        page-break-after: always;
      }
      .page-without-break {
        margin: 5mm auto;
        border: initial;
        border-radius: initial;
        width: initial;
        min-height: initial;
        box-shadow: initial;
        background: initial;
      }

    }

    </style>`;
  }
  if (printType === 'A7') {
    return `<style>
    body {
      width: 100%;
      height: 100%;
      margin: 0;
      padding: 0;
      background-color: #FAFAFA;
      font: 12pt "Arial";
    }
    * {
      box-sizing: border-box;
      -moz-box-sizing: border-box;
    }

    .page {
      width: 100%;
      min-height: 100%;
      // border-radius: 5px;
      background: white;

      // box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    }
    .page-without-break {
      width: 100%;
      min-height: 100%;
      margin: auto auto;
      // border-radius: 5px;
      background: white;
      // box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    }
    .noDisplay{
      display: none;
    }
    .subPage {
      float: left;
      margin: 0;
      padding-top: 5px;
      width: 105mm;
      height: 74.25mm;
      // border: 1px solid black;
      position: relative;
    }
    .transition1{
      transform: translate(-8px,0px)
    }
    .transition2{
      transform: translate(55px,0px)
    }
    .transition3{
      transform: translate(-8px,30px)
    }
    .transition4{
      transform: translate(55px,30px)
    }
    .transition5{
      transform: translate(-8px,100px)
    }
    .transition6{
      transform: translate(55px,100px)
    }
    .transition7{
      transform: translate(-8px,135px)
    }
    .transition8{
      transform: translate(55px,135px)
    }
    .header-area {
      width: 100%;
      position:absolute;
      top:9%;
      color: black;
      font-size: 27pt;
      font-style: arial;
      font-weight: bold;
      text-align: center;
    }

    .header-text {
      color: black;
      font-size: 24pt;
      font-style: arial;
      // padding-bottom: 100px;
      // border:1px solid black;
      font-weight: bold;
      width: 100%;
      text-align: center;
    }

    .center-area {
      width: 100%;
      position:absolute;
      top:25%;
      display: flex;
      flex-direction: column;
    }
    .offer-text {
      justify-content: center;
       margin: 0;
       width: 100%;
       display:flex;
     }

    .price-container {
      position:absolute;
      top:64%;
      width:90%;
      left: 50%;
      transform: translateY(-50%) translateX(-50%);
      display: flex;
      justify-content: space-between;
    }
    .price-label {
      font-style: arial;
      font-size: 16pt;
      font-weight: bold;
    }
    .rupeeSymbol{
      font-weight: bold;
      font-size: 36pt;
      font-family: Arial;
      padding-top: 8px;
    }
    .percentageSymbol{
      font-weight: bold;
      font-size: 36pt;
      font-family: Arial;
      padding-top: 20px;
    }

    .buyClass{
      width: 40%;
      text-align: center;
      font-weight: bold;
      font-size: 38pt;
      font-family: Arial;
      position : absolute;
      top:35%;
      left:40%;
      transform: translateY(-50%) translateX(-50%);
    }
    .ClassSave3{
      width: 75%;
      text-align: center;
      font-weight: bold;
      font-size: 20pt;
      font-family: Arial;
      position : absolute;
      //color: blue;
      top:35%;
      left:40%;
      transform: translateY(-50%) translateX(-50%);
    }

    .savefooter{

    position:fixed;
    left:0;
    bottom:0;
    width:100%;
    //color:red;
    text-align:right;
    left-margin: 1px;
    padding: 10px;

  }

    .offer-text-rupee {
      font-weight: bold;
      font-size: 54pt;
      font-family: Arial;
      vertical-align: super;
      position: relative;
    }
    .mrp-container {
      position: absolute;
      right:4%;
      top:59%;
      // border: 1px solid black;
    }
    .save-container {
      position: absolute;
      left:4%;
      top:59%
    }
   .description {
      position: absolute;
      padding:0;
      left: 50%;
      transform: translateY(-50%) translateX(-50%);
      top:81%;
      width: 65%;
      text-align: center;
       padding:0;
       color: #000000;
       font-weight: bold;
       font-size: 13pt;
       font-family: Arial;
    }
    .familyDescription{
      position: absolute;
      padding:0;
      left: 50%;
      transform: translateY(-50%) translateX(-50%);
      top:75%;
      width: 65%;
      text-align: center;
       padding:0;
       color: #000000;
       font-weight: bold;
       font-size: 11pt;
       font-family: Arial;
    }

  .gstBenefitBelow {
  position: absolute;
  padding:0;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  top: 72%;
  width: 65%;
  text-align: center;
  color: #000000;
  font-weight: bold;
  font-size: 10pt;
  font-family: Arial;
}

.gstAmountHighlight {
  font-size: 16pt;
  font-weight: bold;
  font-family: Arial;
}

    .descriptionWithGst {
      position: absolute;
      padding:0;
      left: 50%;
      transform: translateY(-50%) translateX(-50%);
      top:85%;
      width: 65%;
      text-align: center;
      padding:0;
      color: #000000;
      font-weight: bold;
      font-size: 13pt;
      font-family: Arial;
    }

    .familyDescriptionWithGst{
      position: absolute;
      padding:0;
      left: 50%;
      transform: translateY(-50%) translateX(-50%);
      top:85%;
      width: 65%;
      text-align: center;
       padding:0;
       color: #000000;
       font-weight: bold;
       font-size: 11pt;
       font-family: Arial;
    }




    .description-text {
       text-align: center;
       padding:0;
       color: #000000;
       font-weight: bold;
       font-size: 11pt;
       font-family: Arial;
      //  width: 100%;
     }

    .footer-date {
      position: absolute;
      bottom: 1%;
      font-weight: bold;
      font-size: 5pt;
      font-family: Arial;
      right: 2%
    }
    .validTo {
      position: absolute;
      bottom: 1%;
      font-weight: bold;
      font-size: 5pt;
      font-family: Arial;
      left:2%;
    }
    @page {
      size: A4;
      margin-top: 2mm;
    }
    @media print {
        html, body {
          width: 210mm;
          height: 297mm;
        }
        div {
          break-inside: avoid;
        }
      .page {
        border: initial;
        border-radius: initial;
        width: initial;
        margin: 5mm auto;
        min-height: initial;
        box-shadow: initial;
        background: initial;
        page-break-after: always;
      }
      .page-without-break {
        margin: 5mm auto;
        border: initial;
        border-radius: initial;
        width: initial;
        min-height: initial;
        box-shadow: initial;
        background: initial;
      }

    }

    </style>`;
  }
  if (printType === 'A4MSR') {
    return `<style>
    body {
      width: 100%;
      height: 100%;
      margin: 0;
      padding: 0;
      background-color: #FAFAFA;
      font: 12pt "Arial";
    }
    * {
      box-sizing: border-box;
      -moz-box-sizing: border-box;
    }
    .page {
      width:29.7cm;
      height: 21cm;
      border-radius: 5px;
      background: white;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
      position: relative;
    }
    .sticker.design-5 {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      // border: 1px solid #000;
    }
    .top-section {
      display: flex;
      width: 100%;
      height: 70%;
    }
    .left-column {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 0.3em;
      position: relative;
    }
    .right-column {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 0.3em;
      // border-left: 1px solid #000;
    }
    // .vertical-divider {
    //   width: 1px;
    //   background-color: #000;
    // }
    .rewards-logo {
      position: absolute;
      top: 14%;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0;
    }
    .logo-line-1 {
      display: flex;
      align-items: baseline;
      gap: 2px;
    }
    .logo-my {
      font-family: Arial, sans-serif;
      font-size: 28px;
      font-style: italic;
      font-weight: 400;
      color: #000000;
      line-height: 1;
    }
    .logo-spencers {
      font-family: Arial, sans-serif;
      font-size: 36px;
      font-weight: 700;
      color: #000000;
      line-height: 1;
      text-decoration: underline;
    }
    .logo-rewards {
      font-family: Arial, sans-serif;
      font-size: 42px;
      font-weight: 700;
      color: #000000;
      line-height: 1;
    }
    .rupee-symbol-1 {
      font-size: 42px;
      font-weight: 700;
      vertical-align: top;
      position: relative;
    }
   .rupee-symbol-2 {
      font-size: 80px;
      font-weight: 700;
      vertical-align: top;
      position: relative;
    }
    .member-price-label {
      font-family: Arial, sans-serif;
      font-size: 65px;
      font-weight: 600;
      color: #000000;
      text-align: center;
      margin-top: 40px;
      line-height: 0.9;
    }
    .member-price-value {
      font-family: Arial, sans-serif;
      font-size: 85px;
      margin-top:7px;
      font-weight: 900;
      color: #000000;
      text-align: center;
      line-height: 0.9;
    }
    .non-member-price-label {
      font-family: Arial, sans-serif;
      font-size: 55px;
      font-weight: 600;
      color: #000000;
      text-align: center;
      line-height: 0.9;
    }
    .non-member-price-value {
      font-family: Arial, sans-serif;
      font-size: 70px;
      font-weight: 900;
      margin-top:7px;
      padding-left: 10px;
      color: #000000;
      text-align: center;
      line-height: 0.9;
    }
    .horizontal-divider {
      width: 100%;
      height: 1px;
      min-height: 1px;
      background-color: #000;
      flex-shrink: 0;
    }
    .middle-section {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 0.2em;
      height: 20%;
      width: 100%;
      // border-top: 1px solid #000;
    }
    .product-name {
      font-family: Arial, sans-serif;
      font-size: 42px;
      font-weight: 700;
      color: #000000;
      text-align: center;
      line-height: 1.2;
      letter-spacing: 0.3px;
    }
    .mrp-text {
      font-family: Arial, sans-serif;
      font-size: 60px;
      font-weight: 900;
      color: #000000;
      text-align: center;
      line-height: 1;
    }
    .rupee-symbol-small {
      font-size: 60px;
      font-weight: 900;
      vertical-align: baseline;
    }
    .bottom-section {
      display: flex;
      min-height: auto;
      width: 100%;
      border-top: 1px solid #000;
      padding: 8px;
    }
    .plus-symbol{
    margin-right: 1px;
    }
    .savings-message {
      font-family: Arial, sans-serif;
      font-size: 35px;
      font-weight: 700;
      color: #000000;
      padding-left: 15px;
      text-align: center;
      line-height: 1.2;
      letter-spacing: -1px;
    }
    .bottom-msr-logo{
      margin-left: 5px;
      line-height: 1.2;
      vertical-align: middle;
    }
    .footer-date {
      font-family: Arial, sans-serif;
      font-weight: 700;
      font-size: 10pt;
      position: absolute;
      bottom: -3%;
      right: 3%;
    }
    .validTo {
      font-family: Arial, sans-serif;
      font-weight: 700;
      font-size: 10pt;
      position: absolute;
      bottom: -3%;
      left: 5%;
    }
    @page {
      size: landscape;
      margin: 0;
    }
    @media print {
      html, body {
        width:29.7cm;
        height: 21cm;
      }
      .page {
        margin: 0;
        border: initial;
        border-radius: initial;
        width: initial;
        min-height: initial;
        box-shadow: initial;
        background: initial;
        page-break-after: always;
      }
    }
    </style>`;
  }
  if (printType === 'A7MSR') {
    return `<style>
    body {
      width: 100%;
      height: 100%;
      margin: 0;
      padding: 0;
      background-color: #FAFAFA;
      font: 12pt "Arial";
    }
    * {
      box-sizing: border-box;
      -moz-box-sizing: border-box;
    }
    .page {
      width: 100%;
      min-height: 100%;
      background: white;
    }
    .page-without-break {
      width: 100%;
      min-height: 100%;
      margin: auto auto;
      background: white;
    }
    .subPage {
      float: left;
      margin: 0;
      padding-top: 5px;
      width: 105mm;
      height: 74.25mm;
      position: relative;
    }
    .transition1{
      transform: translate(0px,0px)
    }
    .transition2{
      transform: translate(55px,0px)
    }
    .transition3{
      transform: translate(0px,30px)
    }
    .transition4{
      transform: translate(55px,30px)
    }
    .transition5{
      transform: translate(0px,100px)
    }
    .transition6{
      transform: translate(55px,100px)
    }
    .transition7{
      transform: translate(0px,125px)
    }
    .transition8{
      transform: translate(55px,125px)
    }
    .sticker.design-5 {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    .top-section {
      display: flex;
      width: 100%;
    }
    .left-column {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      gap: 0.3em;
      padding-top: 0.5em;
      padding-bottom: 4px;
    }
    .right-column {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top:30px;
      gap: 0.3em;
      border-left: 1px solid #000;
    }
    .vertical-divider {
      width: 1px;
      min-height: 100%;
      background-color: #000;
    }
    .rewards-logo {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0;
    }
    .logo-line-1 {
      display: flex;
      align-items: baseline;
      gap: 2px;
    }
    .logo-my {
      font-family: Arial, sans-serif;
      font-size: 12px;
      font-style: italic;
      font-weight: 400;
      color: #000000;
      line-height: 1;
    }
    .logo-spencers {
      font-family: Arial, sans-serif;
      font-size: 12px;
      font-weight: 700;
      color: #000000;
      line-height: 1;
      text-decoration: underline;
    }
    .logo-rewards {
      font-family: Arial, sans-serif;
      font-size: 20px;
      font-weight: 700;
      color: #000000;
      line-height: 1;
    }
    .rupee-symbol-1 {
      font-size: 20px;
      font-weight: 700;
      vertical-align: top;
      position: relative;
    }
    .rupee-symbol-2 {
      font-size: 36px;
      font-weight: 700;
      vertical-align: top;
      position: relative;
    }
    .member-price-label {
      font-family: Arial, sans-serif;
      font-size: 32px;
      font-weight: 700;
      color: #000000;
      text-align: center;
      line-height: 0.9;
      letter-spacing: -0.1px;
    }
    .member-price-value {
      font-family: Arial, sans-serif;
      font-size: 36px;
      font-weight: 700;
      color: #000000;
      text-align: center;
      line-height: 1;
    }
    .non-member-price-label {
      font-family: Arial, sans-serif;
      font-size: 28px;
      font-weight: 700;
      color: #000000;
      text-align: center;
      line-height: 0.9;
      letter-spacing: -0.1px;
    }
    .non-member-price-value {
      font-family: Arial, sans-serif;
      font-size: 32px;
      font-weight: 700;
      color: #000000;
      text-align: center;
      line-height: 0.9;
    }
    .horizontal-divider {
      width: 100%;
      height: 1px;
      min-height: 1px;
      background-color: #000;
      flex-shrink: 0;
    }
    .middle-section {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-top: 1px solid #000;
      padding-top: 8px;
      gap: 0.2em;
      height: 20%;
      width: 100%;
    }
    .product-name {
      font-family: Arial, sans-serif;
      font-size: 12px;
      font-weight: 700;
      color: #000000;
      text-align: center;
      line-height: 1.2;
      letter-spacing: 0.3px;
    }
    .mrp-text {
      font-family: Arial, sans-serif;
      font-size: 20px;
      font-weight: 700;
      color: #000000;
      text-align: center;
      line-height: 1.2;
    }
    .rupee-symbol-small {
      font-size: 20px;
      font-weight: 700;
      vertical-align: baseline;
    }
    .bottom-section {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: auto;
      width: 100%;
      padding: 4px;
      border-top: 1px solid #000;
    }
    .plus-symbol{
    margin-right: 1px;
    }
    .savings-message {
      font-family: Arial, sans-serif;
      font-size: 12px;
      font-weight: 700;
      color: #000000;
      line-height: 1.3;
      letter-spacing: -1px;
    }
    .bottom-msr-logo{
      margin-left: 4px;
      line-height: 1.2;
      vertical-align: middle;
    }
    .footer-date {
      font-family: Arial, sans-serif;
      font-weight: 700;
      font-size: 10pt;
      position: absolute;
      bottom: 0%;
      right: 3%;
    }
    .validTo {
      font-family: Arial, sans-serif;
      font-weight: 700;
      font-size: 10pt;
      position: absolute;
      bottom: 0%;
      left: 5%;
    }
    // .bottom-section {
    //   display: flex;
    //   align-items: center;
    //   justify-content: center;
    //   min-height: auto;
    //   width: 100%;
    //   padding: 0 4px;
    // }
    // .savings-message {
    //   font-family: Arial, sans-serif;
    //   font-size: 12px;
    //   font-weight: 700;
    //   color: #000000;
    //   line-height: 1.2;
    //   letter-spacing: -0.2px;
    // }
    @page {
      size: A4;
      margin-top: 2mm;
    }
    @media print {
      html, body {
        width: 210mm;
        height: 297mm;
      }
      div {
        break-inside: avoid;
      }
      .page {
        border: initial;
        border-radius: initial;
        width: initial;
        margin: 5mm auto;
        min-height: initial;
        box-shadow: initial;
        background: initial;
        page-break-after: always;
      }
      .page-without-break {
        margin: 5mm auto;
        border: initial;
        border-radius: initial;
        width: initial;
        min-height: initial;
        box-shadow: initial;
        background: initial;
      }
    }
    </style>`;
  }
  return `<style>
  body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    background-color: #FAFAFA;
    font: 12pt "Arial";
  }
  * {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
  }
  .page {
    width:29.7cm;
    height: 21cm;
    border-radius: 5px;
    background: white;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    position: relative;
  }
  .noDisplay{
    display: none;
  }
  .header-area {
    width: 100%;
    position:absolute;
    top:5%;
    color: black;
    font-size: 67pt;
    font-style: arial;
    font-weight: bold;
    text-align: center;
  }

  .center-area {
    width: 100%;
    position:absolute;
    top:23%;
    display: flex;
    flex-direction: column;
  }
  .offer-text {
    justify-content: center;
     margin: 0;
     width: 100%;
     display:flex;
   }

  .price-container {
    position:absolute;
    top:68%;
    width:90%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    display: flex;
    justify-content: space-between;
  }
  .price-label {
    font-style: arial;
    font-size: 40pt;
    font-weight: bold;
  }

  .mrp-container{
    position: absolute;
    right:5%;
    top:65%;
  }
  .save-container{
    position: absolute;
    left:5%;
    top:65%
  }
  .rupeeSymbol{
    font-weight: bold;
    font-size: 120pt;
    font-family: Arial;
    padding-top: 20px;
  }
  .percentageSymbol{
    font-weight: bold;
    font-size: 80pt;
    font-family: Arial;
    padding-top: 115px;
  }

  .buyClass{
    width: 50%;
    text-align: center;
    font-weight: bold;
    font-size: 90pt;
    font-family: Arial;
    //color:green;
    position : absolute;
    // line-height:120pt;
    top:36%;
    left:43%;
    transform: translateY(-50%) translateX(-50%);
  }
    .longText{
    width: 80%;
    text-align: center;
    font-weight: bold;
    font-size: 45pt;
    font-family: Arial;
    //color:green;
    position : absolute;
    // line-height:120pt;
    top:36%;
    left:43%;
    transform: translateY(-50%) translateX(-50%);
  }
  .ClassSave3{
    position: absolute;
    padding:1;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    top:40%;
    //color:blue;
    width: 80%;
    text-align: center;
    padding:1;
    font-weight: bold;
    font-size: 63pt;
    font-family: Arial;
  }

  .offer-text-rupee {
    font-weight: bold;
    font-family: Arial;
    font-size: 180pt;
    position: relative;

  }

 .description {
    position: absolute;
    padding:0;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    top:90%;
    width: 65%;
    text-align: center;
    color: #000000;
    font-weight: bold;
    font-size: 34pt;
    font-family: Arial;
  }
  .familyDescription{
    position: absolute;
    padding:0;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    top:80%;
    width: 65%;
    text-align: center;
    padding:0;
    color: #000000;
    font-weight: bold;
    font-size: 34pt;
    font-family: Arial;
  }

  .descriptionWithGst {
  position: absolute;
  padding:0;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  top: 89%;
  width: 65%;
  text-align: center;
  color: #000000;
  font-weight: bold;
  font-size: 34pt;
  font-family: Arial;
}

.familyDescriptionWithGst {
  position: absolute;
  padding:0;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  top: 89%;
  width: 65%;
  color: #000000;
  font-weight: bold;
  font-size: 34pt;
  font-family: Arial;
}

/* gst line just above description */
.gstBenefitBelow {
  position: absolute;
  padding:0;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  top: 78%;
  width: 65%;
  text-align: center;
  color: #000000;
  font-weight: bold;
  font-size: 30pt;
  font-family: Arial;
}

.gstAmountHighlight {
  font-size: 38pt;
  font-weight: bold;
  font-family: Arial;
}

  .price-text-area {
      padding: 25px;
      float: left;
      font-weight: bold;
      font-style: arial;
      font-size: 38pt;
  }
   .price-text-area2 {
    float:right:
      padding: 25px;
      font-weight: bold;
      font-style: arial;
      font-size: 38pt;
  }

  .savefooter{

    position:fixed;
    left:0;
    bottom:0;
    width:100%;
    //color:red;
    text-align:right;
    left-margin: 200px;

  }

  .footer-text {
    color: #000000;
    font-weight: bold;
    font-size: 34pt;
    font-family: Arial;
    width: 100%;
 }

  .footer-date {
    // float: right;
    font-weight: bold;
    font-size: 10pt;
    font-family: Arial;
    // margin-left:24cm;
    position: absolute;
    bottom: -5%;
    right: 3%;
  }
  .validTo {
    font-weight: bold;
    font-size: 10pt;
    font-family: Arial;
    position: absolute;
    bottom: -5%;
    left: 5%;
  }
  @page {
    size: landscape;
    margin: 0;
  }
  @media print {
      html, body {
        width:29.7cm;
        height: 21cm;
      }
  .page {
    margin: 0;
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
  </style>`;
};

const divideArrInSubArr = data => {
  const divideInSubpartOf = 8;
  let subArr = [];
  const arr = [];
  if (data.length > 0) {
    for (let index = 0; index < data.length; index += 1) {
      const element = data[index];
      if ((index + 1) % divideInSubpartOf === 0) {
        subArr.push(element);
        arr.push(subArr);
        subArr = [];
      } else {
        subArr.push(element);
      }
    }
    if (subArr.length > 0) {
      arr.push(subArr);
    }
    return arr;
  }
  return [];
};

/**
 * Compute non-member offer price from pop fields (same logic as SAVE/OUR PRICE in templates).
 * Uses offerPrice, then percentageOff, then rupeesOff.
 */
const getOfferPriceFromPop = item => {
  if (!item || item.mrp == null) return 0;
  const mrp = Number(item.mrp);
  const offerPrice = Number(item.offerPrice) || 0;
  const percentageOff = Number(item.percentageOff) || 0;
  const rupeesOff = Number(item.rupeesOff) || 0;
  if (offerPrice > 0) return offerPrice;
  if (percentageOff > 0) {
    const price = (100 - percentageOff) / 100 * mrp;
    return Number.isInteger(price) ? price : Number(price.toFixed(2));
  }
  if (rupeesOff > 0) return mrp - rupeesOff;
  return mrp;
};

/**
 * Compute member price (MSR) after applying POP offer on MRP.
 * 1) Compute base non-member offer price via getOfferPriceFromPop (offerCommunication on MRP)
 * 2) Then apply myrdOfferCommunication fields on top of that base:
 *    - myrdOfferPrice (absolute), then myrdPercentageOff, then myrdRupeesOff.
 */
const getMemberPriceFromMyrd = item => {
  if (!item || item.mrp == null) return 0;

  const basePrice = getOfferPriceFromPop(item);
  const safeBase = Number(basePrice);
  if (!safeBase || Number.isNaN(safeBase)) return 0;

  const myrdOfferPrice = Number(item.myrdOfferPrice) || 0;
  const myrdPercentageOff = Number(item.myrdPercentageOff.toFixed(2)) || 0;
  const myrdRupeesOff = Number(item.myrdRupeesOff.toFixed(2)) || 0;

  // Absolute member price overrides sequential logic
  if (myrdOfferPrice > 0) return myrdOfferPrice;

  // Percentage off is applied on top of already-discounted base price
  if (myrdPercentageOff > 0) {
    const price = (100 - myrdPercentageOff) / 100 * safeBase;
    return Number.isInteger(price) ? price : Number(price.toFixed(2));
  }

  // Rupees off is subtracted from the base price
  if (myrdRupeesOff > 0) {
    const price = safeBase - myrdRupeesOff;
    return Number.isInteger(price) ? price : Number(price.toFixed(2));
  }

  // No MSR-specific discounts; member pays the same as non-member offer price
  return safeBase;
};

/**
 * Enrich a POP item for MSR print: set memberPrice and offerPrice for display.
 * - If myrdOfferPrice has value: use numeric prices (getMemberPriceFromMyrd, getOfferPriceFromPop).
 * - If Rupee Off: use numeric prices.
 * - If Percentage Off only: show offer text — member = myrdPop1 + pop1 when myrdPercentageOff set, non-member = pop1.
 */
const enrichMsrArticleForPrint = item => {
  if (!item) return item;
  const rupeesOff = Number(item.rupeesOff) || 0;
  const percentageOff = Number(item.percentageOff) || 0;
  const myrdOfferPrice = Number(item.myrdOfferPrice) || 0;
  const myrdPercentageOff = Number(item.myrdPercentageOff) || 0;

  if (myrdOfferPrice > 0) {
    return {
      ...item,
      memberPrice: getMemberPriceFromMyrd(item),
      offerPrice: getOfferPriceFromPop(item)
    };
  }
  if (rupeesOff > 0) {
    return {
      ...item,
      memberPrice: getMemberPriceFromMyrd(item),
      offerPrice: getOfferPriceFromPop(item)
    };
  }
  if (percentageOff > 0) {
    const nonMemberPrice = Number.isInteger(percentageOff)
      ? `${percentageOff}% off`
      : `${percentageOff.toFixed(2)}% off`;
    if (myrdPercentageOff > 0) {
      const combined = percentageOff + myrdPercentageOff;
      const memberPrice = Number.isInteger(combined)
        ? `${combined}% off`
        : `${combined.toFixed(2)}% off`;
      return {
        ...item,
        memberPrice,
        offerPrice: nonMemberPrice
      };
    }
    return {
      ...item,
      memberPrice: nonMemberPrice,
      offerPrice: nonMemberPrice
    };
  }
  return {
    ...item,
    memberPrice: getMemberPriceFromMyrd(item),
    offerPrice: getOfferPriceFromPop(item)
  };
};

export default {
  getTemplatePrintCss,
  divideArrInSubArr,
  getOfferPriceFromPop,
  getMemberPriceFromMyrd,
  enrichMsrArticleForPrint
};
